<template>
    <b-modal ref="my-modal" hide-footer :title="plain_file.filename">
      <div>{{plain_file.header}}</div>
      <div v-for="item in plain_file.pallets">{{item}}</div>
      <div>&&</div>


    </b-modal>
</template>

<script>
    export default {
        name: "Plano",
      props: ['plain_file'],
      methods: {
        showModal() {
          this.$refs['my-modal'].show()
        },
        hideModal() {
          this.$refs['my-modal'].hide()
        },
      }
    }
</script>

<style scoped>

</style>
